import React from 'react'
import styled from 'styled-components'
import convertUnit from 'lib/unit'
import {Button} from '../Button'
import {ButtonOutline} from '../ButtonOutline'
import {ButtonChoiceProps} from './ButtonChoiceProps'

interface StyledContainerProps {
  isVertical?: boolean
}

const StyledContainer = styled.div<StyledContainerProps>`
  ${({isVertical}) => ({
    gap: convertUnit(isVertical ? 12 : 20),
    flexDirection: isVertical ? 'column-reverse' : 'row',
  })}
  display: flex;
  width: 100%;
`

const StyledButton = styled(Button)`
  width: 100%;
`

const StyledButtonOutline = styled(ButtonOutline)`
  width: 100%;
`

export default function ButtonChoice({
  buttonIsVertical = false,
  primaryLabel,
  primaryIsDisabled,
  primaryOnClick,
  secondaryLabel,
  secondaryIsDisabled,
  secondaryIsOutline = false,
  secondaryOnClick,
}: ButtonChoiceProps) {
  return (
    <StyledContainer isVertical={buttonIsVertical}>
      {secondaryIsOutline ? (
        <StyledButtonOutline
          label={secondaryLabel}
          disabled={secondaryIsDisabled}
          borderColor="primary_5"
          borderHoverColor="primary_4"
          color="primary_5"
          onClick={secondaryOnClick}
        />
      ) : (
        <StyledButton
          label={secondaryLabel}
          disabled={secondaryIsDisabled}
          backgroundColor="white_3"
          backgroundHoverColor="gray_2"
          color="primary_5"
          onClick={secondaryOnClick}
        />
      )}
      <StyledButton
        label={primaryLabel}
        disabled={primaryIsDisabled}
        onClick={primaryOnClick}
      />
    </StyledContainer>
  )
}
